// extracted by mini-css-extract-plugin
export default {"root":"mixing-modal_root__a8F_Z","text":"mixing-modal_text__VIFMn","footerModal":"mixing-modal_footerModal__qUS8j","actionBtn":"mixing-modal_actionBtn__yo2kW"};